/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PriceOracle, PriceOracleInterface } from "../PriceOracle";

const _abi = [
  {
    inputs: [
      {
        internalType: "int256",
        name: "_answer",
        type: "int256",
      },
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "oldRoot",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newRoot",
        type: "address",
      },
    ],
    name: "RootOwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "description",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "getAnswer",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint80",
        name: "_roundId",
        type: "uint80",
      },
    ],
    name: "getRoundData",
    outputs: [
      {
        internalType: "uint80",
        name: "roundId",
        type: "uint80",
      },
      {
        internalType: "int256",
        name: "answer",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "startedAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "updatedAt",
        type: "uint256",
      },
      {
        internalType: "uint80",
        name: "answeredInRound",
        type: "uint80",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "getTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isManager",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latestAnswer",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latestRound",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latestRoundData",
    outputs: [
      {
        internalType: "uint80",
        name: "roundId",
        type: "uint80",
      },
      {
        internalType: "int256",
        name: "answer",
        type: "int256",
      },
      {
        internalType: "uint256",
        name: "startedAt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "updatedAt",
        type: "uint256",
      },
      {
        internalType: "uint80",
        name: "answeredInRound",
        type: "uint80",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "latestTimestamp",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "root",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
      {
        internalType: "bool",
        name: "role",
        type: "bool",
      },
    ],
    name: "setManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferRootOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "_answer",
        type: "int256",
      },
    ],
    name: "updateAnswer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "version",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PriceOracle__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _answer: BigNumberish,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PriceOracle> {
    return super.deploy(
      _answer,
      forwarder,
      overrides || {}
    ) as Promise<PriceOracle>;
  }
  getDeployTransaction(
    _answer: BigNumberish,
    forwarder: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_answer, forwarder, overrides || {});
  }
  attach(address: string): PriceOracle {
    return super.attach(address) as PriceOracle;
  }
  connect(signer: Signer): PriceOracle__factory {
    return super.connect(signer) as PriceOracle__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PriceOracleInterface {
    return new utils.Interface(_abi) as PriceOracleInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PriceOracle {
    return new Contract(address, _abi, signerOrProvider) as PriceOracle;
  }
}
